import VendorSearch from './VendorSearch';

export default VendorSearch;
